<template>
    <div class="body">
        <div class="title">
            管理员登录日志
            <!-- 面包屑导航区域 -->
            <div class="fansk">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/shouye' }" class="dsadf">
                        <span class="dsadf">首页</span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>管理员登录日志</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <div class="btnsearch">
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                        <el-input placeholder="管理员ID" v-model="Query.data.admin_id" @input="discountSearch">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker type="daterange" value-format="yyyy-MM-dd" @change="discountSearch"
                            v-model="Query.data.login_time_range" placeholder="查询日期">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <vxe-table border show-overflow keep-source ref="xTable" max-height="750" class="mytable-scrollbar"
            :data="tableData" align="center" :edit-config="{
                trigger: 'click',
                mode: 'cell',
                icon: 'fa fa-pencil',
                showStatus: true,
            }">
            <!-- <vxe-table-column type="seq" width="60"></vxe-table-column> -->
            <vxe-table-column field="id" title="ID" width="100"></vxe-table-column>
            <vxe-table-column field="admin_realname" title="管理员" width="200"></vxe-table-column>
          <vxe-table-column field="admin_name" title="协会名称" width="300"></vxe-table-column>
            <vxe-table-column field="token" title="TOKEN"></vxe-table-column>
            <vxe-table-column field="token_time" title="TOKEN时间" width="180"></vxe-table-column>
            <vxe-table-column field="client_ip" title="客户端ip" width="150"></vxe-table-column>
            <vxe-table-column field="login_time" title="登录时间" width="180"></vxe-table-column>
        </vxe-table>
        <div v-if="pageshow">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page"
                :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {
    adminTokenList
} from "@/api/rizhi";

export default {
    // name: "index",
    components: {},
    data() {
        return {
            tableData: [],
            Query: {
                base: {
                    token: sessionStorage.getItem("token"),
                    page: 1,
                    limit: 10,
                },

                data: {
                    admin_id: '',
                    login_time_range: ''
                }
            },
            total: null,
            pageshow: true,
            cur_page: 1,
        };
    },
    created() {
        this.getList();
    },
    methods: {
        discountSearch() {
            this.cur_page = 1;
            this.getList();
            this.pageshow = false; // 让分页隐藏
            this.$nextTick(() => {
                // 重新渲染分页
                this.pageshow = true;
            });
        },
        handleSizeChange(val) {
            this.Query.base.limit = val;
            this.handleCurrentChange(this.Query.base.page);
        },
        handleCurrentChange(val) {
            this.Query.base.page = val;
            this.getList();
        },
        getList() {
            adminTokenList(this.Query).then(({ data: res }) => {
                console.log("res", res);
                this.tableData = res.data;
                this.total = res.extend.total_count;
            });
        },
    },
};
</script>

<style scoped lang="less">
.body {
    display: flex;
    flex-direction: column;

    .title {
        opacity: 1;
        font-size: 30px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #2e2e2e;
        letter-spacing: 0px;
        margin-bottom: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .fansk {
            margin-top: 30px;
            margin-left: 32px;
        }

        .dsadf {
            color: #3d9aff;
        }
    }

    .btnsearch {
        display: flex;
        flex-direction: row;
        align-items: center;

        .left {
            margin-right: 150px;
        }

        .right {
            margin-top: 27px;
        }
    }
}
</style>
